export function getAgesString(agesArray) {
    if ((!agesArray) || (agesArray === undefined)) {
        return "";
    }

    const agesObject = agesArray.reduce(
        (agesObj, age) => {
            if ((!age) && (!age[0])) {
                return agesObj;
            }

            const ageIsArray = !!(age[0] && age[0].id && age[0].name);
            // eslint-disable-next-line no-unused-vars
            const ageIsObj = !!(age && age.id && age.name);
            const currentAge = (ageIsArray) ? age[0] : age;

            if (
                Number.parseInt(currentAge.id, 10) === 200
                || Number.parseInt(currentAge.id, 10) === 201
            ) {
                return {
                    ...agesObj,
                    babies: [...agesObj.babies, currentAge],
                };
            }

            if (
                Number.parseInt(currentAge.id, 10) === 127
                || Number.parseInt(currentAge.id, 10) === 255
                || Number.isNaN(Number.parseInt(currentAge.name, 10))
            ) {
                return {
                    ...agesObj,
                    other: [...agesObj.other, currentAge],
                };
            }

            return {
                ...agesObj,
                children: [...agesObj.children, currentAge],
            };
        },
        {
            babies: [],
            children: [],
            other: [],
        },
    );

    const stringPartOne = ((ages) => {
        if (ages.length < 1) {
            return "";
        }
        if (ages.length < 2) {
            return ages[0].name;
        }

        return `${ages[0].name.split("-")[0]}-${ages[1].name.split("-")[1]}`;
    })(agesObject.babies);

    const stringPartTwo = ((ages) => {
        if (ages.length < 1) {
            return "";
        }
        const addComma = (stringPartOne !== "") ? ", " : "";

        const parts = ages.reduce((partsArray, age) => {
            const lastSegment = partsArray.at(-1);
            const lastAge = lastSegment ? lastSegment.split("-").at(-1) : false;
            const firstAge = lastSegment ? lastSegment.split("-")[0] : false;
            const currentAge = Number.parseInt(age.name, 10);

            if (!lastAge) {
                return [`${age.name}`];
            }

            const lastAgeInt = Number.parseInt(lastAge, 10);
            const nextSequentialAge = lastAgeInt + 1;

            if (nextSequentialAge === currentAge) {
                return [
                    ...partsArray.slice(0, -1),
                    `${firstAge}-${currentAge}`,
                ];
            }

            if (nextSequentialAge !== currentAge) {
                return [
                    ...partsArray,
                    age.name,
                ];
            }

            return partsArray;
        }, []);

        const partString = parts.reduce((str, part) => {
            const comma = (str !== "") ? ", " : "";

            return `${str}${comma}${part}`;
        }, "");

        return `${addComma}${partString} Years`;
    })(agesObject.children);

    const stringPartThree = ((ages) => {
        if (ages.length < 1) {
            return "";
        }

        const commaStart = (
            (stringPartTwo !== "")
            || ((stringPartOne !== "") && (stringPartTwo === ""))
        ) ? ", " : "";

        return ages.reduce((str, age) => {
            const addComma = (str !== ", " && str !== "") ? ", " : "";

            if (age.name === "18+") {
                return `${str}${addComma}Adults`;
            }

            if (age.name === "pregnancy") {
                return `${str}${addComma}Pregnancy`;
            }

            if (!age.name) {
                return str;
            }

            return `${str}${addComma}${age.name}`;
        }, commaStart);
    })(agesObject.other);

    const agesPrefix = (stringPartOne !== "" || stringPartTwo !== "") ? "Ages " : "";

    return `${agesPrefix}${stringPartOne}${stringPartTwo}${stringPartThree}`;
}

export default {
    getAgesString,
};
